import React, { Component } from "react";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  Button,
} from "mdbreact";
import { Card, CardHeader } from "reactstrap";
import BreadCumb from "../Department/BreadCumb";
import { PostData } from "../../api/service";
import { Container, Typography } from "@material-ui/core";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

// const facultyData = [
//     {
//         name: 'Dr. Jogesh Kakati',
//         desg: 'Principal',
//         qualification: 'MA, PhD',
//         email: '',
//         phone: '',
//         mobile: '',
//         specifications: '',
//         cv: '',
//         photo: ''
//     },

// ]

export default class PrincipalContainer extends Component {
  state = {
    facultyData: [],
    isLoaded: false,
    dept_code: "OFF",
  };

  componentDidMount() {
    let d = {
      dept_code: "OFF",
      type: "PRINCIPAL",
    };

    PostData(`/getemployeebytype`, d).then((resp) => {
      //console.log(resp)
      this.setState({
        ...resp[0],
        facultyData: resp,
        isLoaded: true,
      });
    });
  }
  render() {
    return (
      <div>
        <BreadCrumbOwn title="Principal's Message" />

        <Container className="mb-5">
          <br />

          {this.state.isLoaded &&
            this.state.facultyData.map((el, index) => {
              return (
                <div>
                  {/* <Card style={{ boxShadow: 'none' }}>
                            <CardHeader style={{ color: 'white', boxShadow: 'none', backgroundColor: '#1E3760', textAlign: 'center' }}> <h3 style={{color: 'inherit'}}>{el.desg}</h3></CardHeader>
                        </Card> */}

                  <div>
                  <div>
                        <div style={{ textAlign: "left" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            style={{
                              width: "350px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div>

                        {/* <h5
                          style={{
                            fontSize: "16px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          {el.name}<br />
                          Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya<br />
						               Eraligool, Sribhumi
                        </h5> */}
                       
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          {/* <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a> */}
                        </h6>
                      </div>
                    <div>
                      <Typography
                        variant="h5"
                        style={{ margin: "1em 0", fontWeight: 700 }}
                        gutterBottom
                      >
                        WELCOME MESSAGE FROM THE PRINCIPAL
                      </Typography>
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        
                      </Typography>

                      <br />

                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        I am immensely pleased to announce the commencement of a new academic session, 2025-2026 at Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya (PDUAM), Eraligool, Sribhumi. Through collaboration with various stakeholders of the Mahavidyalaya, we have effectively concluded all the preceding academic sessions since the inception. I warmly welcome all the eager students of the Mahavidyalaya and express gratitude to their parents and guardians for choosing this institution for their children's higher education. The establishment of the Mahavidyalaya dates back to 2017, when the first Government Science Model Degree College was established in the Barak Valley. This institution stands as a visionary initiative of the Government of Assam, financially supported by the Rastriya Uchchatar Shiksha Abhiyan (RUSA) for the rural and economically weaker sections of Society. The Mahavidyalaya commenced its maiden academic journey from the academic session 2017-2018, offering Higher Secondary (10+2) courses in Science under the Assam Higher Secondary Education Council, Bamunimaidam, Guwahati, and Under-graduate (UG) Science programmes leading to Bachelor of Science (B.Sc) under Assam University, Silchar. Now, the Mahavidyalaya has emerged as a truly multidisciplinary higher education institution by offering Four-Year Undergraduate (FYUG) Programmes in both Arts and Science streams based on the NEP 2020 curriculum, under Assam University, Silchar, from the academic session 2023-2024. The FYUG Programmes in Science are offered in six subjects, such as Physics, Chemistry, Mathematics, Botany, Zoology, Statistics, and the FYUG Programmes in Arts are offered in seven subjects that include English, Bengali, Economics, Education, Sociology, Political Science, and History. It is to be mentioned here that the FYUG Programmes in Arts were introduced at the Mahavidyalaya from the academic session 2023-2024. To provide high-quality Arts and Science education at the UG level, the Mahavidyalaya has an appropriate infrastructure in place, including academic buildings and laboratories. Various workshops focusing on different aspects of Arts and Science education and research, as well as numerous co-curricular activities, are regularly organised on the days of national significance. The Mahavidyalaya has completed infrastructure projects such as the construction of girls’ hostel, boundary walls, and residential complexes for staff, along with sports and Health buildings. Plans are underway to establish a gymnasium for the fitness needs of both the students and employees. Further infrastructure development includes the construction of a canteen and an academic annexed building.
                      </Typography>

                      <br/>
                      
                      

                      <div>
                        {/* <div style={{ textAlign: "right" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            style={{
                              width: "250px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div> */}

                        <h4
                          style={{
                            fontSize: "20px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          {el.name}<br />
                          Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya<br />
						               Eraligool, Sribhumi
                        </h4>
                       
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        {/* <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a>
                        </h6> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Container>
      </div>
    );
  }
}
